module.exports = __webpack_public_path__ + "img/left_top_hong.cd40dc70.png";